import { Type } from "@sinclair/typebox";
export const Nullable = (schema) => Type.Union([schema, Type.Null()]);
export const FormattedNullableString = (options) => Nullable(Type.String(options));
export const NullableString = Nullable(Type.String());
export const NullableNumber = Nullable(Type.Number());
export const IdLike = Type.Union([Type.Number(), Type.String()]);
export const NullableIdLike = Nullable(IdLike);
